import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth.service'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {

            if (err.status === 401) {
                // auto logout if 401 response returned from api
                // Skip logout/reload for FCM token calls to prevent infinite loop
                const isFcmRequest = request.url.includes('save-fcm-token') || request.url.includes('delete-fcm-token');
                if (!isFcmRequest && !(request.body && request.body.grant_type == 'password')) {
                    this.auth.logout();
                    location.href = '';
                }
            }
            // else{

            // }
            const error = err.error?.message || err.statusText;
            return throwError(() => err.error);
        }))
    }
}